import api, { ResponsePayloadWithData } from '../../../../../api';
import type { AdaptiveAssessmentQExercise, ContentType } from '../../../../../api/medialink';
import type { Status } from '../../../../../utils/results';

interface Score extends Pick<AdaptiveAssessmentQExercise, 'phases' | 'isLastPhase'> {
  achievable: number;
  achieved: number;
  maximum: number;
  achievedAt?: string;
  status: Status;
  amountOfItems: number; // this is used for getMaterialByAssignment in user-material api, but not available in student finished assignment api
  duration: number;
}

export type FinishedStudentAssignment = {
  id: string;
  moduleId: string;
  materialId: string;
  materialType: 'medialink' | 'user-material';
  contentType: ContentType;
  name: string;
  from: string;
  to: string;
  repeatable: boolean;
  reviewable: boolean;
  sessionId?: string;
  owner: {
    firstName: string;
    lastName: string;
  };
  score: Score;
  hierarchy: {
    id: string;
    title: string;
    prefix?: string;
  }[];
};

export async function getFinishedStudentAssignments(superModuleId: string) {
  const { data } = await api.get<ResponsePayloadWithData<FinishedStudentAssignment[]>>(
    `/studio/user/modules/${superModuleId}/assignments/student/finished`,
  );

  return data.data;
}
